// @ts-strict-ignore
import clsx from 'clsx'
import Image from 'next/image'
import { useRouter } from 'next/navigation'
import React, { useState } from 'react'

import { useProduct } from '@/screens/Product/hooks/useProduct'

import { Slider } from '@/widgets/slider'

import { SvgArrowDown } from '@/shared/lib/@deprecated/iport-icons/iconsA/SvgArrowDown'
import { BASE_URL } from '@/shared/lib/const/env'
import { createMarkup } from '@/shared/lib/utils/common/createMarkup'
import { formatPrice } from '@/shared/lib/utils/price/format-price'
import { Button } from '@/shared/ui'
import { Modal } from '@/shared/ui'
import { FullScreenModal } from '@/shared/ui/full-screen-modal'
import { Heading } from '@/shared/ui/heading'

import cl from './limited-box.module.scss'

type LimitedBoxProps = {
	className?: string
}

export const LimitedBox = ({ className }: LimitedBoxProps): JSX.Element | null => {
	const { product } = useProduct()
	const [isOpen, setIsOpen] = useState(false)
	const [isDesktop, setIsDesktop] = useState(false)
	const router = useRouter()

	const info = product?.INFO

	React.useEffect(() => {
		if (typeof window !== 'undefined') {
			setIsDesktop(window.matchMedia('(min-width: 700px)').matches)
		}
	}, [])

	const open = () => setIsOpen(true)
	const close = () => setIsOpen(false)

	if (!info?.ID) return null

	const onButtonClick = (event: Event) => {
		event.stopPropagation()
		router.push(`/order/${product.ID},${info?.ID}?kod=${product.KOD}`)

		close()
	}

	const modalContent = (
		<div className={cl.modal}>
			<div className={cl.header}>
				<div className={cl.imageWrapper}>
					<Slider
						className={cl.slider}
						autoplay={false}
						slides={info.GALLERY.map(src => (
							<Image
								src={BASE_URL + src}
								key={src}
								alt=""
								width={347}
								height={267}
								className={clsx(cl.img, cl.img_desktop)}
								priority={true}
							/>
						))}
					/>
				</div>
			</div>
			<div className={cl.content}>
				<Heading preset="h3" className={cl.title}>
					{info.TITLE || 'Limited Box'}
				</Heading>
				<div className={cl.info}>
					<div className={cl.price}>{typeof info.PRICE === 'number' ? formatPrice(info.PRICE) : null}</div>

					{/* @ts-ignore */}
					<Button fullWidth theme="primary" size="L" onClick={onButtonClick}>
						Добавить к заказу
					</Button>
				</div>
				<div className={cl.bottomContent} dangerouslySetInnerHTML={createMarkup(info.TEXT_UNDEX_BUTTON)} />
			</div>
		</div>
	)

	return (
		<div className={cl.animation}>
			<div
				className={clsx(cl.root, className)}
				style={{
					background: !!info?.COLOR_BUTTON ? info.COLOR_BUTTON : `linear-gradient(to right, #e6f1ff, #568dfe)`
				}}>
				<Image
					className={clsx(cl.image, cl.banner__background__desktop)}
					src={BASE_URL + info.IMAGES[1]}
					quality={100}
					width={40}
					height={40}
					alt={info.TITLE}
					aria-hidden
				/>
				<Button className={cl.button} theme="clear" onClick={open}>
					{info.TEXT_BUTTON}
				</Button>
				<SvgArrowDown size={30} className={cl.icon} color="#fff" />
				{isDesktop ? (
					<Modal isOpen={isDesktop ? isOpen : false} onClose={close} contentClassName={cl.modalContent}>
						{modalContent}
					</Modal>
				) : (
					<FullScreenModal open={isDesktop ? false : isOpen} onClose={close} coloredBg>
						{modalContent}
					</FullScreenModal>
				)}
			</div>
		</div>
	)
}
